import moment from "moment";
import DatetimeHelper from "~/helpers/datetimeHelper";
import {DatetimeMode} from '~/models/datetimeMode'

export let DateHelper = {
  fromNow: function(expression: string): Date {
    const amount = toMilliseconds(expression)
    const now = new Date(Date.now())
    return new Date(now.getTime() + amount)
  },
  toLocalTimeString(date: Date): string {
    return DatetimeHelper.toLocalTimeString(date.toISOString())
  },
  coerceDate(date: Date | string | number): moment.Moment {
    if (typeof date === 'number') {
      if (date > 60) date -= 1;
      return moment(new Date(1899, 11, 31)).add(date, 'days');
    } else if (typeof date === 'string' && /^\d+$/.test(date)) {
      date = parseInt(date, 10);
      if (date > 60) date -= 1;
      return moment(new Date(1899, 11, 31)).add(date, 'days');
    } else {
      return moment(date);
    }
  },
  /**
   * Ignore the timezone when the display mode is not +DatetimeMode.Datetime+.
   *
   * @param date
   * @param mode
   * @param timezone
   */
  toDisplay(date: string, {mode, timezone}: {mode: DatetimeMode, timezone: string}): string {
    // essentially ignore timezone arg if for date only since timezone is irrelevant
    if (mode !== DatetimeMode.Datetime) timezone = 'UTC';
    return DatetimeHelper.toZonedTimeString(date, { timezone: timezone, format:  DatetimeHelper.displayFormat(mode)})
  },
  /**
   * In current timezone
   */
  now(): Date {
    return new Date(Date.now())
  },
  beginningOfDay(date: Date): Date {
    return moment(date).startOf('day').toDate()
  },
  beginningOfMinute(date: Date): Date {
    return moment(date).startOf('minute').toDate()
  },
  /**
   * Remove timezone info - changes the actual point in time
   * @param date
   */
  toUTC(date: Date): Date {
    return new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      date.getHours(),
      date.getMinutes(),
      date.getSeconds(),
      date.getMilliseconds(),
    ))
  },
  prevOccuring(weekday: string): moment.Moment {
    let ago = new Date().getDay() - weekNameToDay[weekday]
    if (ago <= 0) {
      ago += 7
    }
    return moment().subtract(ago,'d').startOf('day')
  },
  nextOccuring(weekday: string): moment.Moment {
    let ago = weekNameToDay[weekday] - new Date().getDay()
    if (ago <= 0) {
      ago += 7
    }
    return moment().add(ago,'d').startOf('day')
  },
}

const toMilliseconds = (expression: string): number => {
  const transforms: {[key in IDurationUnits]?: number} = {}
  const segments = expression.split(' and ')
  segments.forEach(segment => {
    const [amount, unit] = segment.split(' ')
    transforms[unit] = parseInt(amount, 10)
  })
  let milliseconds = 0
  for (const [unit, amount] of Object.entries(transforms)) {
    milliseconds += amount * conversionToMilliseconds[unit]
  }
  return milliseconds
}

type IDurationUnits = 'day' | 'days' | 'week' | 'weeks'

const conversionToMilliseconds: {[key in IDurationUnits]: number} = {
  day: 24 * 60 * 60 * 1000,
  days: 24 * 60 * 60 * 1000,
  week: 24 * 60 * 60 * 1000 * 7,
  weeks: 24 * 60 * 60 * 1000 * 7,
} as const

const weekNameToDay = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
}
